/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { action, observable } from 'mobx';

export type CompositeEntitiesMigrationTrackerStatus = 'creatingNewVersion' | 'trainingNewVersion' | 'migrationFailed';

export class CompositeEntitiesMigrationTrackerStore {
    @observable
    public updatedEntitiesIds: string[] = [];

    @observable
    public stateProgressPercentage: number = 0;

    @observable
    public state: CompositeEntitiesMigrationTrackerStatus = null;

    @observable
    public failureReason: string = '';

    /**
     * Updates the array of the migrated entities' ids.
     */
    @action
    public setUpdatedEntitiesIds(newIds: string[]) {
        this.updatedEntitiesIds = newIds;
    }

    /**
     * Updates the state progress percentage.
     */
    @action
    public setStateProgressPercentage(newPercentage: number) {
        this.stateProgressPercentage = newPercentage;
    }

    /**
     * Updates the state.
     */
    @action
    public setState(newState: CompositeEntitiesMigrationTrackerStatus) {
        this.state = newState;
    }

    /**
     * Updates the failure reason.
     */
    @action
    public setFailureReason(reason: string) {
        this.failureReason = reason;
    }
}
